import React from 'react';
import { NavLink } from 'react-router-dom';
import './navbar.css'; // Import CSS for styling

const NavBar = () => {
  return (
    <header className="header">
    <h3>CoffeeStain</h3>
      <nav className="navbar">
        <div className="container">
          <div className="nav-elements">
            <ul>
              <li>
                <NavLink to="/" activeClassName="active">Home</NavLink>
              </li>
              <li>
                <NavLink to="/projects" activeClassName="active">Projects</NavLink>
              </li>
              <li>
                <NavLink to="/about" activeClassName="active">About Me</NavLink>
              </li>
              {/* <li> */}
                {/* <NavLink to="/dorker" activeClassName="active">Google Dorker</NavLink> */}
              {/* </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default NavBar;
